<template>
   <div class="gift">
        <div class="gift-section">
            {{ showGiftDesc }}
        </div>
        <div class="gift-section" v-for="item in showGiftGroup" :key="item?.labelName">
            <div class="gift-label">
                <img
                    :src="item?.labelUrl"
                />
                <span>{{ item.labelName }}</span>
            </div>
            <div>
                {{ item.content }}
            </div>
        </div>
        <div style="width: 100%;height: 40px;"></div>
   </div>
</template>

<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { mapState } from "vuex";
import { getTextByRoleIdAndPalce, placeKeysMap } from "../../roleJs";

export default {
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  props: {
    roleId: {
      type: Number,
      default: NaN,
    },
    giftData: {
        type: Array,
        default: () => {
          return [
              {
                  labelName: 'Collector',
                  labelUrl: require('@/assets/images/YuliApp/guiderole/icon_collector.png'),
                  content: 'As a member of the Purifiers in Yuliverse, their mission is to protect this world and its people from threats of the unknown. As Purifiers, they have extraordinary talents in collecting Stardust for various production purposes in order to better protect themselves and others.'
              },
              {
                  labelName: 'Explorer',
                  labelUrl: require('@/assets/images/YuliApp/guiderole/icon_replicant.png'),
                  content: 'In addition, Purifiers also have the talent of explorers. They can interact more proficiently with Terra to obtain more resources. This talent makes them more confident and brave when exploring and facing challenges.'
              }
          ]
        },
    },
  },
  data() {
    return {};
  },
  watch: {
    giftData: {
      handler(value) {
        if(value?.length > 0){
          this.showGiftGroup = value;
          // 需要对字段
        }
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
          this.initHandle();
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props) {
    const { id, roleId} = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const currentShow = ref(1);
    const showGiftDesc = ref('');
    const showGiftGroup = ref(
        [
            {
                labelName: 'Collector',
                labelUrl: require('@/assets/images/YuliApp/guiderole/icon_collector.png'),
                content: 'As a member of the Purifiers in Yuliverse, their mission is to protect this world and its people from threats of the unknown. As Purifiers, they have extraordinary talents in collecting Stardust for various production purposes in order to better protect themselves and others.'
            },
            {
                labelName: 'Explorer',
                labelUrl: require('@/assets/images/YuliApp/guiderole/icon_replicant.png'),
                content: 'In addition, Purifiers also have the talent of explorers. They can interact more proficiently with Terra to obtain more resources. This talent makes them more confident and brave when exploring and facing challenges.'
            }
        ]
    )

    const initHandle = () => {
      const getKey = getTextByRoleIdAndPalce(roleId, placeKeysMap.gift.desc1);
      showGiftDesc.value = localesPackage.value?.[getKey]?.[localesEnv.value];
    }

    return {
      initHandle,
      currentShow,
      showGiftGroup,
      showGiftDesc,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
.gift{
    box-sizing: border-box;
    padding: 0 24px;
    width: 100%;
    color: rgba(255,255,255,0.7);
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: left;
    padding-bottom: 25%;

    &-section{
        margin-bottom: 28px;
        line-height: 20px;
    }

    &-label{
        width: 100%;
        height: 44px;
        margin-bottom: 4px;
        position: relative;
        img{
            position: absolute;
            left: -6px;
            top: 50%;
            transform: translate(0,-50%);
            width: 44px;
            height: 44px;
            margin-right: 2px;
        }
        span{
            position: absolute;
            left: 40px;
            top: 50%;
            transform: translate(0,-40%);
            width: fit-content;
            height: 28px;
            color: #f5f5f5;
            font-size: 20px;
            font-weight: 600;
            font-family: "PingFang SC";
            text-align: left;
        }
    }
}
</style>